<tr
    class="prom-list-element"
    class:prom-list-element--checked={checked}
    class:prom-list-element--header={header}
    class:prom-list-element--right={alignTextRight}
    class:prom-list-element--dragged={dragged}
    on:click={click}
>
    <slot />
</tr>

<script>
    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

    /** @type {boolean} */
    export let checked = false;
    /** @type {boolean} */
    export let dragged = false;
    /** @type {boolean} */
    export let header = false;
    /** @type {boolean} */
    export let alignTextRight = false;
    /** @type {boolean} */
    export let checkOnClick = false;

    function click() {
        if (checkOnClick) {
            checked = !checked;
        }
        dispatch('click', { checked });
    }
</script>
